import { render, staticRenderFns } from "./orderDriverCustomizeDetails.vue?vue&type=template&id=993aa280&scoped=true"
import script from "./orderDriverCustomizeDetails.vue?vue&type=script&lang=js"
export * from "./orderDriverCustomizeDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDriverCustomizeDetails.vue?vue&type=style&index=0&id=993aa280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993aa280",
  null
  
)

export default component.exports